import { FC, useEffect, useState } from "react";
import useAxios from "../../../hooks/useAxios";
import { IGetSchoolRecords, ISchoolRecord } from "../../../models/schools.model";
import useLoader from "../../../hooks/useLoader";
import { getSchoolRecords, postSchoolRecords } from "../../../api/schools.api";
import useUtil from "../../../hooks/useUtil";
import { useTranslation } from "react-i18next";

interface IProps {
  memberCode?: string;
  isEdit: boolean;
  setIsEdit: (isEdit: boolean) => void;
  submitTrigger: boolean;
};

const SchoolRecordTable: FC<IProps> = ({
  memberCode,
  isEdit,
  setIsEdit,
  submitTrigger,
}) => {
  const { t } = useTranslation();
  const { getDetailCodes } = useUtil();
  const { data: res, isLoading, error, execute } = useAxios<IGetSchoolRecords>();
  const { data: postRes, isLoading: postIsLoading, error: postError, execute: postExecute } = useAxios();
  useLoader(
    isLoading || postIsLoading,
    [error, postError],
  );

  const [data, setData] = useState<ISchoolRecord[]>([]);
  const [isFirstRun, setIsFirstRun] = useState(true);  
  // MB0016: 내신시험유형
  const MB0016 = getDetailCodes('MB0016');

  useEffect(() => {
    if (memberCode) {
      execute(getSchoolRecords(memberCode));
    }
  }, [memberCode]);

  useEffect(() => {
    if (res?.data && MB0016?.length) {
      const newData: ISchoolRecord[] = [];
      MB0016.forEach(code => {
        const schoolRecord = res.data.find(item => item.examType === code.detailCode);
        if (schoolRecord) {
          newData.push(schoolRecord);
        } else {
          newData.push({
            examType: code.detailCode,
            score: '',
          });
        }
      });
      setData(newData);
    }
  }, [res, MB0016]);

  useEffect(() => {
    if (isFirstRun) {
      setIsFirstRun(false);
      return;
    }
    onSubmit();
  }, [submitTrigger]);

  useEffect(() => {
    if (postRes) {
      setIsEdit(false);
    }
  }, [postRes]);

  const getInput = (gradeIndex: number, examTypeIndex: number) => {
    const dataIndex = gradeIndex * 4 + examTypeIndex;
    const schoolRecord = data[dataIndex];

    return (
      <input
        type="text"
        className="form-control form-control-sm w-100p"
        value={schoolRecord?.score}
        onChange={e => {
          const value = e.target.value;
          if (/^[0-9]*$/.test(value)) {
            const newData = [...data];
            newData[dataIndex] = {
              ...schoolRecord,
              score: value,
            };
            setData(newData);
          }
        }}
      />
    );
  };

  const getScore = (gradeIndex: number, examTypeIndex: number) => {
    const schoolRecord = data[gradeIndex * 4 + examTypeIndex];
    return schoolRecord?.score || '-';
  };

  const onSubmit = () => {
    if (!memberCode) {
      return;
    }
    const req: ISchoolRecord[] = [];
    data.forEach(item => {
      if (item.score) {
        req.push(item);
      }
    });
    postExecute(postSchoolRecords(memberCode, req));
  };

  return (
    <>
      <div className="comm-bx__between">
        <div>
          <h4 className="sub-title">{t('student.student.57')}</h4>
        </div>
      </div>
      <div className='comm-table__area line-type'>
        <table>
          <thead>
            <tr>
              <th>{t('student.student.13')}</th>
              <th>{t('student.student.31')}</th>
              <th>{t('student.student.58')}</th>
              <th>{t('student.student.59')}</th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3].map((grade, index) => (
              <>
                <tr>
                  <th rowSpan={4}>{grade}</th>
                  <th rowSpan={2}>1</th>
                  <th>{t('student.student.60')}</th>
                  <td>
                    <div className="flex flex-justify-center">
                      {isEdit ? getInput(index, 0) : getScore(index, 0)}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t('student.student.61')}</th>
                  <td>
                    <div className="flex flex-justify-center">
                      {isEdit ? getInput(index, 1) : getScore(index, 1)}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th rowSpan={2}>2</th>
                  <th>{t('student.student.60')}</th>
                  <td>
                    <div className="flex flex-justify-center">
                      {isEdit ? getInput(index, 2) : getScore(index, 2)}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t('student.student.61')}</th>
                  <td>
                    <div className="flex flex-justify-center">
                      {isEdit ? getInput(index, 3) : getScore(index, 3)}
                    </div>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default SchoolRecordTable;